import { useTranslation } from 'react-i18next';
import { KoobAlert } from '@koob/ui';

/**
 * Warns that a product of the itinerary was never distributed to us. Reuses the
 * Experience Factsheet alert so the two surfaces stay visually identical.
 *
 * `variant="global"` is the banner at the top of the itinerary (how many
 * products are concerned, what can be done); the default is the per-product
 * warning rendered next to the product it concerns.
 */
export default function ComposeProductAccessAlert({
  count = 0,
  variant = 'product',
}) {
  const { t } = useTranslation('tripDesigner');

  if (variant === 'global' && count === 0) {
    return null;
  }

  return (
    <KoobAlert variant="warning" icon="fa-info-circle">
      <div className="flex w-full flex-col gap-1">
        <span>
          {variant === 'global'
            ? t('productAccess.globalDescription', { count })
            : t('productAccess.productDescription', {
                defaultValue:
                  'This product was not distributed to your organization',
              })}
        </span>
      </div>
    </KoobAlert>
  );
}
